import axios from "axios";
import {Toaster} from "../helper/Toaster";
import {toast} from "react-toastify";
import authManager from "../helper/AuthHelper";
import persianNumberFormat from "../helper/PersianNumberFormat";


function getCookie(name) {
  const cookieValue = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
  return cookieValue ? cookieValue.pop() : '';
}

function isTokenExpired(token, expiration) {
  if (!token || !expiration) {
    return true;
  }
  const tokenExpiration = new Date(expiration);
  const currentDateTime = new Date();

  return currentDateTime > tokenExpiration;
}

function setToken(name) {
  let token = localStorage.getItem('token');
  let expiration = localStorage.getItem('expiration');
  if (isTokenExpired(token, expiration)) {
    axios.defaults.headers["Authorization"] = "";
  } else {
    axios.defaults.headers["Authorization"] = "Bearer " + token;
  }
}

function setHeaderContentTypeJson() {
  axios.defaults.headers.post["Content-Type"] = "application/json";
  axios.defaults.headers.put["Content-Type"] = "application/json";
}

setHeaderContentTypeJson()
// axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
const csrftoken = getCookie('csrftoken');
axios.defaults.headers.common['X-CSRFToken'] = csrftoken;
setToken()


axios.interceptors.response.use(response => {
  setHeaderContentTypeJson()
  if ((response.config.method === "post" || response.config.method === "put") && response.status >= 200 && response.status < 300) {
    if (response.data.hasOwnProperty("message")) {
      toast.success(response.data.message);
    }
  }

  return response;
}, error => {
  setHeaderContentTypeJson()
  if (error && error.code === "ERR_NETWORK") {
    Toaster.failure(null, "ارتباط با سرور برقرار نشد. از اتصال اینترنت خود مطمئن شوید");
    return [];
  }
  const expectedErrors =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (error.response.status === 401) {
    Toaster.failure(null, "زمان جلسه شما تمام شده است. لطفا مجدد لاگین کنید");
    authManager.logoutHandler()
  } else if (!expectedErrors) {
    Toaster.failure(null, "مشکلی از سمت سرور رخ داده است.");
    return error.response;
  } else {
    Toaster.failure(null, persianNumberFormat(error.response.data.error));
    return false;
  }

  return Promise.reject(error);
});

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  hasFile: () => {
    axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
    axios.defaults.headers.put["Content-Type"] = "multipart/form-data";
  }
};
